import { useState, useEffect, useRef, useCallback } from "react";

const SLIDES = [
  {
    id: 1,
    carriers: [
      {
        name: "Aegis Specialty Division",
        logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcf5RBtaa3jgY29d55f17luupmRQ39tDI0oQ&s",
      },
      {
        name: "Foremost",
        logo: "https://www.greatflorida.com/html/content/carriers/foremost.webp",
      },
      {
        name: "Ergo Next",
        logo: "https://mlxwx3bywoz1.i.optimole.com/w:200/h:222/q:auto/dpr:2.6/f:best/https://www.mattisonins.com/wp-content/uploads/sites/1255/2026/01/ergo-next-logo-5.jpg",
      },
    ],
  },
  {
    id: 2,
    carriers: [
      {
        name: "Pie Insurance",
        logo: "https://www.pieinsurance.com/_next/image?url=https%3A%2F%2Fcdn.builder.io%2Fapi%2Fv1%2Fimage%2Fassets%252Fb3f4fdb80a8d4c9884b91e16fa0d2aab%252Fff279f980ea54bfcac0adaf7435458ec&w=640&q=100",
      },
      {
        name: "Three by Berkshire Hathaway",
        logo: "https://agents.threeinsurance.com/assets/logo-primary-BOPeZdKi.png",
      },
      {
        name: "Bamboo",
        logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzBMDkt47v0MLVSDE03U-EA04s_v0adwphju7hdTPomRMBRScz",
      },
    ],
  },
  {
    id: 3,
    carriers: [
      {
        name: "Hiscox",
        logo: "https://i.pinimg.com/736x/62/5a/67/625a67b0184cce9c9cc516c4de97aaca.jpg",
      },
      {
        name: "American Modern",
        logo: "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcSqR7g08Nhsp0-9RfKblcDfThA8OdlY7s6hrQwUdiQX1JlLPOiy",
      },
      {
        name: "KW Specialty Insurance Company",
        logo: "https://media.licdn.com/dms/image/v2/D5622AQFZIxT4jh5Umg/feedshare-shrink_800/B56Zj2fuEQG0As-/0/1756482167643?e=2147483647&v=beta&t=NztzAKdhYZFc1Wwe7B0UGR93c06LimC_GPnhrcebBE0",
      },
    ],
  },
  {
    id: 4,
    carriers: [
      {
        name: "The Hartford",
        logo: "https://logowik.com/content/uploads/images/the-hartford3414.logowik.com.webp",
      },
      {
        name: "California Fair Plan",
        logo: "https://media.licdn.com/dms/image/sync/v2/D4E27AQE2N4Olp6SWXw/articleshare-shrink_800/B56Zz8w0F0KIAI-/0/1773767182652?e=2147483647&v=beta&t=58xy-4X-9oJNongnyg5uwSr4CxJvlA_043jd_jLJY5c",
      },
      {
        name: "USLI",
        logo: "https://www.pngfind.com/pngs/m/566-5660189_united-states-underwriters-insurance-company-united-usli-insurance.png",
      },
    ],
  },
  {
    id: 5,
    carriers: [
      {
        name: "Seaview Insurance Company",
        logo: "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcTnGViDnkwFn92Mwb-ryvTojbAN4KNMstDt15y9E63tIbTMs3SP",
      },
      {
        name: "Spinnaker Insurance Company",
        logo: "https://peeplesinsurance.com/wp-content/uploads/Spinnaker-Insurance-Logo-400x112.png",
      },
      {
        name: "State National",
        logo: "https://www.statenational.com/wp-content/uploads/2020/09/admin-ajax.png",
      },
    ],
  },
  {
    id: 6,
    carriers: [
      {
        name: "Travelers",
        logo: "https://media.licdn.com/dms/image/v2/D4E22AQFGiiGtYQGDqg/feedshare-shrink_800/B4EZ1uTosOGQAc-/0/1775672134690?e=2147483647&v=beta&t=qjYCjKxakqDkqoAZ3F8mBEyfZErguOYd9bcGIGcqT8c",
      },
      {
        name: "biBerk",
        logo: "https://ervinandsmith.com/wp-content/uploads/2023/02/biberk.png",
      },
      {
        name: "Bristol West",
        logo: "https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcSS9jlw3BoBvhVQafxkOBqlRgU8q88VeVbIFOIpU3fNfgV9el_E",
      },
    ],
  },
];
function useInView(threshold = 0.12) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

function CarrierLogo({ carrier }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group flex items-center justify-center w-full h-full px-8 py-10 sm:px-12 sm:py-12 transition-transform duration-300 ease-in-out hover:scale-105">
      {imgError ? (
        <span className="font-serif text-center text-sm tracking-wide text-blue-900 opacity-50">
          {carrier.name}
        </span>
      ) : (
        <img
          src={carrier.logo}
          alt={carrier.name}
          onError={() => setImgError(true)}
          className="w-auto object-contain opacity-90 transition-all duration-300 ease-in-out group-hover:opacity-100 group-hover:scale-105"
          style={{ maxWidth: "180px", maxHeight: "80px" }}
        />
      )}
    </div>
  );
}

export default function PartnershipSection() {
  const [current, setCurrent] = useState(0);
  const [visible, setVisible] = useState(true);
  const [headingRef, headingInView] = useInView(0.1);
  const [gridRef, gridInView] = useInView(0.08);
  const hoveringRef = useRef(false);
  const total = SLIDES.length;

  const goTo = useCallback((index) => {
    setVisible(false);
    setTimeout(() => {
      setCurrent(index);
      setVisible(true);
    }, 350);
  }, []);

  const next = useCallback(() => {
    goTo((current + 1) % total);
  }, [current, total, goTo]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!hoveringRef.current) next();
    }, 4000);
    return () => clearInterval(interval);
  }, [next]);

  const slide = SLIDES[current];

  return (
    <section
      className="relative w-full overflow-hidden py-20 sm:py-28"
      style={{ backgroundColor: "#F7F4EF" }}
    >
      {/* Dot pattern — inline: radial-gradient not in base Tailwind */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgba(1,46,114,0.055) 1px, transparent 0)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 sm:px-8 lg:px-12">

        {/* ── Heading ── */}
        <div
          ref={headingRef}
          className={`text-center mb-14 sm:mb-20 transition-all duration-[850ms] ease-out ${
            headingInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-7"
          }`}
        >
          {/* Eyebrow — centered, single dash on left only */}
          <div className="flex items-center justify-center gap-3 mb-4 sm:mb-5">
            <div className="h-px w-7 bg-blue-900/40 flex-shrink-0" />
            <span
              className="font-serif uppercase text-blue-900/60 font-normal tracking-[0.25em]"
              style={{ fontSize: "11px" }}
            >
              Partnerships
            </span>
          </div>

          {/* Headline — centered */}
          <h2
            className="font-serif font-bold text-blue-900 leading-[1.1] tracking-tight mb-5 sm:mb-6"
            style={{ fontSize: "clamp(32px, 4.5vw, 52px)" }}
          >
            Our <em className="italic font-bold">Trusted</em>
            <br />
            Partner Carriers
          </h2>

          {/* Subtitle — centered */}
          <p className="font-serif text-base text-gray-600 leading-relaxed max-w-lg mx-auto">
            We work with the nation's most respected carriers to deliver
            competitive rates and reliable coverage — giving you options without
            compromise.
          </p>
        </div>

        {/* ── Logo Grid ── */}
        <div
          ref={gridRef}
          className={`transition-all duration-[850ms] delay-200 ease-out ${
            gridInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-7"
          }`}
          onMouseEnter={() => { hoveringRef.current = true; }}
          onMouseLeave={() => { hoveringRef.current = false; }}
        >
          {/* Top rule — fades on both ends */}
          <div
            className="w-full h-px"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(1,46,114,0.18) 20%, rgba(1,46,114,0.18) 80%, transparent)",
            }}
          />

          {/* Responsive grid:
              mobile  → 1 col (stacked)
              sm      → 2 cols
              md+     → 3 cols  */}
          <div
            className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 transition-opacity duration-[350ms] ease-in-out ${
              visible ? "opacity-100" : "opacity-0"
            }`}
          >
            {slide.carriers.map((carrier, i) => (
              <div
                key={carrier.name}
                className="relative flex items-center justify-center min-h-[180px] sm:min-h-[200px]"
              >
                {/* Vertical divider — fades top & bottom, hidden on mobile */}
                {i < slide.carriers.length - 1 && (
                  <>
                    {/* Mobile: horizontal fade divider between stacked rows */}
                    <div
                      className="absolute bottom-0 left-0 right-0 h-px sm:hidden"
                      style={{
                        background:
                          "linear-gradient(90deg, transparent, rgba(1,46,114,0.18) 20%, rgba(1,46,114,0.18) 80%, transparent)",
                      }}
                    />
                    {/* sm+: vertical fade divider on right edge */}
                    <div
                      className="absolute right-0 top-0 bottom-0 w-px hidden sm:block"
                      style={{
                        background:
                          "linear-gradient(180deg, transparent, rgba(1,46,114,0.18) 20%, rgba(1,46,114,0.18) 80%, transparent)",
                      }}
                    />
                  </>
                )}
                <CarrierLogo carrier={carrier} />
              </div>
            ))}
          </div>

          {/* Bottom rule — fades on both ends */}
          <div
            className="w-full h-px"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(1,46,114,0.18) 20%, rgba(1,46,114,0.18) 80%, transparent)",
            }}
          />
        </div>
      </div>
    </section>
  );
}